import React from 'react';

interface TestRightSidebarProps {
  activeTab?: string;
}

const TestRightSidebar: React.FC<TestRightSidebarProps> = ({ activeTab = 'tab1' }) => {

  const getWidgetContent = () => {
    switch (activeTab) {
      case 'tab1':
        return (
          <>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 1</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the first widget
              </div>
            </div>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 2</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the second widget
              </div>
            </div>
          </>
        );
      case 'tab2':
        return (
          <>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 1</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the first widget
              </div>
            </div>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 2</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the second widget
              </div>
            </div>
          </>
        );
      case 'tab3':
        return (
          <>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 1</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the first widget
              </div>
            </div>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 2</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the second widget
              </div>
            </div>
          </>
        );
      case 'tab4':
        return (
          <>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 1</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the first widget
              </div>
            </div>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 2</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the second widget
              </div>
            </div>
          </>
        );
      case 'tab5':
        return (
          <>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 1</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the first widget
              </div>
            </div>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 2</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the second widget
              </div>
            </div>
          </>
        );
      default:
        return (
          <>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 1</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the first widget
              </div>
            </div>
            <div className="visual-card-small">
              <div className="visual-card-header">
                <h5 className="text-heading-small">Widget 2</h5>
              </div>
              <div style={{ padding: '8px' }}>
                This is the second widget
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div className="widget-container">
      {getWidgetContent()}
    </div>
  );
};

export default TestRightSidebar;